const core = require("@material-ui/core")

const makeStyles = () => {
    return core.makeStyles((theme) => ({
        main: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justify: 'center',
            minHeight: '100vh',
            position: "relative",
            color: '#96979C',
            fontSize: '20px',
            paddingBottom: '70px',
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main,
        },
        container: {
            marginBottom: "80px"
        }
    }));
}

const createMuiTheme = (props) => {
    return () =>
    core.createMuiTheme({
        typography: {
            fontFamily: [
                'Muli', 'sans-serif'
            ].join(','),
        },
        palette: {
            type: props.darkMode ? 'dark' : 'light',
            primary: {
                main: "#00AEEF"
            },
        },
        overrides: {
            MuiOutlinedInput: {
                root: {
                    backgroundColor: "white",
                    color: "black",
                    fontSize: "20px"
                },
                input: {
                    paddingTop: "15px",
                    paddingBottom: "15px"
                }
            },
            MuiContainer: {
                root: {
                    paddingLeft: 0,
                    paddingRight: 0,
                }
            },
            MuiPaper: {
                root: {
                    color: '#96979C',
                    fontSize: '20px'
                }
            },
            MuiAppBar: {colorPrimary: {backgroundColor: "#FFC0CB"}, width: "100%"},
            MuiDivider:
                {
                    root: {
                        backgroundColor: "#00AEEF"
                    }
                },
            MuiButtonBase: {
                root: {
                    height: '32px'
                }
            },
            MuiButton: {
                root: {
                    borderRadius: "25px",
                    fontWeight: "bold",
                    textShadow: '0px 10px 20px rgba(0, 0, 0, 0.15)',
                },
                contained: {
                    boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.15);',
                    color: 'rgba(255, 255, 255, 0.8)',
                    // padding: '0px 5px 0px 10px',
                    // verticalAlign: 'middle',
                    // boxSizing: 'content-box' // border-box

                },
                containedPrimary: {
                    color: '#feffff'
                },
                outlined: {
                    color: "#00AEEF",
                    borderColor: "#00AEEF",
                    // padding: '0px 10px 0px 10px',
                    // verticalAlign: 'middle',
                    // boxSizing: 'content-box'
                },
                containedSizeLarge: {
                    fontSize: '20px',
                    boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.15);',
                    background: 'linear-gradient(161.86deg, #72D9FF 2.1%, #4A7DFA 100%)',
                    color: 'rgba(255, 255, 255, 0.8)',
                },
                label: {
                    fontWeight: 'bold',
                }


            },
            MuiDrawer: {
                paper: {
                    backgroundColor: '#323334'
                }
            },

            MuiTypography: {
                body1: {
                    fontSize: '20px',
                    lineHeight: '25px'
                }
            },
            MuiExpansionPanel: {
                root: {
                    backgroundColor: "#323334",
                },
                // rounded: {
                //     '&:first-child': {
                //         borderTopLeftRadius: '4px',
                //         borderTopRightRadius: '4px',
                //         marginTop: '0px'
                //     },
                //     '&:last-child': {
                //         borderBottomLeftRadius: '4px',
                //         borderBottomRightRadius: '4px'
                //     }
                // }
            },
            MuiExpansionPanelDetails: {
                root: {
                    padding: '8px 20px 16px'
                }
            },
            MuiExpansionPanelSummary: {
                root: {
                    '&$expanded': {
                        minHeight: '48px'
                    }
                },
                expandIcon: {
                    color: '#00AEEF',
                    '&$expanded': {
                        color: 'white'
                    }
                },
                content: {
                    fontSize: '24px',
                    '&$expanded': {
                        color: 'white',
                        margin: '12px 0 12px 0'
                    }
                }
            },

            MuiFormControl: {
                marginNormal: {marginTop: "0px", marginBottom: "10px"}
            },

            MuiIconButton: {
                root: {
                    padding: 'inherit',
                    paddingRight: '15px',
                    verticalAlign: 'middle'
                }
            },
            MuiSelect: {
                icon: {
                    color: '#00AEEF'
                },
                nativeInput: {
                    border: '0px'
                }
            }
        }
    });
};

export { createMuiTheme, makeStyles }